<template>
    <div class="cart-box">
        <div v-if="products.length && !finished && !payOnline" class="cart-box-full">
            <div style="margin-bottom: 25px">
                <div v-for="(product, index) in products" :key="index" class="cart-product-box">
                    <div class="cart-product-box__body">
                        <div style="
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
" @click="removeProduct(product)">
                            <inline-svg src="/img/icons/close-box.svg" width="25" height="25" :fill="$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                        </div>

                        <div style="margin-right: 14px;">
                            <img :src="product.thumbnail" style="width: 125px;border-radius: 8px;">
                        </div>

                        <div style="width: 100%;">
                            <div class="cart-product-box__title">
                                {{ product.title }} ({{ product.size }})
                            </div>
                            <div class="cart-product-box__description">
                                <span v-if="(product.size == '30 см' && product.weight_30 > 0) || (product.size == '50 см' && product.weight_50 > 0)" class="product-box-description__weight">{{
                                        product.size == '30 см' ? product.weight_30 : product.weight_50
                                }} г – </span>
                                {{ product.description }}
                            </div>
                            <div style="text-align: left;font-size: 0.8rem;color: #aaa;margin-top: 4px"
                                 v-if="product.additionaIngredients.length">
                                <b>Додатки: </b> <span v-for="(ingredient, index) in product.additionaIngredients"
                                                       :key="ingredient.index">{{ ingredient.title }}<span
                                v-if="index < product.additionaIngredients.length - 1">, </span> </span>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 30px;text-align: left;display: flex;justify-content: space-between;align-items: center;width: 100%">
                        <div style="font-weight: 700">
                            {{ product.price }} грн
                        </div>

                        <div class="quantity-box">
                            <div class="quanity-button quanity-button--minus" @click="changeQuanity('minus', product, index)">
                                -
                            </div>
                            <div class="quanity-input">{{ product.quanity }}</div>
                            <div class="quanity-button quanity-button--plus" @click="changeQuanity('plus', product, index)">
                                +
                            </div>
                        </div>
                    </div>

                    <div style="margin: 8px 0 0 auto; font-weight: 700">
                        Сума: <span style="color: #AB2321;">{{ getProductPrice(product) }} грн</span>
                    </div>
                </div>
                <div class="cart-free-beverage-box" v-if="secondPizzaOfDiscount">
                    <div style="color: rgba(255, 206, 0, 0.68)">При замовленні 2-х піц напій на вибір – безкоштовно!</div>
                    <div class="free-beverage__list">
                        <div v-for="(freeBeverage, index) in freeBeverages" :key="freeBeverage.id"
                             :class="(freeBeverage.id == getSelectedFreeBeverageId() ? 'selected-free-beverage': '') + ' free-beverage__item'"
                             style="padding: 2px;opacity: 0.4;font-size: 0.9rem;" @click="changeFreeBeverage(index)">
                            <img :src="freeBeverage.thumbnail" style="width: 80px;border-radius: 8px">
                            <div style="margin-top: 7px;text-align: center">
                                {{ freeBeverage.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="cart-total-amounts">
                    <div class="cart-total-amounts__title">Сума:</div>
                    <div class="cart-total-amounts__value">{{ getTotalPrice() }} грн</div>
                </div>
                <div class="cart-total-amounts">
                    <div class="cart-total-amounts__title">Знижка:</div>
                    <div class="cart-total-amounts__value">{{ getTotalDiscount() }} грн</div>
                </div>
                <div class="cart-total-amounts">
                    <div class="cart-total-amounts__title">До сплати:</div>
                    <div class="cart-total-amounts__value">{{ getTotalPrice() - getTotalDiscount() }} грн</div>
                </div>
                <div class="cart-total-amounts" v-if="takeAwayDiscount">
                    <div class="cart-total-amounts__title">Самовиніс (-7%):</div>
                    <div class="cart-total-amounts__value">{{ Math.round(takeAwayDiscount) }} грн</div>
                </div>
                <div class="cart-total-amounts" v-if="fourPizzaDiscount">
                    <div class="cart-total-amounts__title" style="color: rgba(255, 206, 0, 0.68)">На кожну 4-ту піцу – знижка 50%:</div>
                    <div class="cart-total-amounts__value">{{ Math.round(fourPizzaDiscount) }} грн</div>
                </div>
            </div>

            <!-- <div style="text-align: left;padding-bottom: 14px;" v-if="secondPizzaOfDiscount">
                Друга піца (-35%): -{{ Math.round(secondPizzaOfDiscount, 2)}} грн
            </div> -->

            <div
                style="text-align: left;padding-bottom: 14px;background-color: rgba(255, 206, 0, 0.68);padding: 14px;font-size: 0.9rem;"
                v-if="showThreePizzaDiscount">
                Якщо Ви замовляєте 3 піци – 4-та (найдешевша у чеку) –лише за 50% вартості. Оберіть, будь ласка, 4-ту
                піцу, щоб
                отримати знижку!
            </div>

            <div class="cart-order-type-box">
                <div @click="changeOrderType('delivery')" :class="type == 'delivery' ? 'order-type-text-selected' : 'order-type-text'">
                    Доставка
                </div>

                <div @click="changeOrderType('take-away')" :class="type == 'take-away' ? 'order-type-text-selected' : 'order-type-text'">
                    Самовиніс
                </div>
            </div>

            <div style="
    margin-top: 25px;
    margin-bottom: 14px;
    text-align: left;
    color: #fb3431;
    font-weight: bold;
" v-if="errors.length">
                <div v-for="error in errors" :key="error">
                    {{ error }}
                </div>
            </div>

            <div style="text-align: left;margin-top: 25px;">
                <div>
                    <input type="text" :class="(!userInfo.name ? 'is-invalid': 'is-valid') + ' form-control'" v-model="userInfo.name" placeholder="Ім'я">
                </div>
                <div style="margin-top: 14px;">
                    <input type="text" :class="(!isValidPhone ? 'is-invalid': 'is-valid') + ' form-control'" v-model="userInfo.phone" @keyup="validatePhoneField" placeholder="Номер телефону">
                </div>

                <div v-if="type == 'take-away' && takeawayLocations.length > 0">
                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;">
                            Оберіть точку для самовиносу:
                        </div>
                        <select :class="(!userInfo.location_id ? 'is-invalid': 'is-valid') + ' form-control'" v-model="userInfo.location_id" required>
                            <option value="" disabled selected>Точка для самовиносу</option>
                            <option :value="location.id" v-for="location in takeawayLocations" :key="location.id">{{ location.address }}</option>
                        </select>
                    </div>

                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;">Час самовиносу:</div>
                        <select class="form-control" id="exampleFormControlSelect2" v-model="userInfo.delivery_at">
                            <option v-for="time in this.deliveryWorkTimes" :value="time.value">
                                {{ time.start }} {{ time.end ? '- ' + time.end  : ''}}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="type == 'delivery'">
                    <div style="margin-top: 14px">
                        <select :class="(!userInfo.city ? 'is-invalid': 'is-valid') + ' form-control'" id="exampleFormControlSelect1" v-model="userInfo.city"
                                v-on:change="selectCity" required>
                            <option value="" disabled selected>Населений пункт</option>
                            <option :value="city.name" v-for="city in cities" :key="city.id">{{ city.name }}</option>
                        </select>
                    </div>

                    <div style="margin-top: 14px;position: relative;" v-if="userInfo.city">
                        <input type="text" :class="(!userInfo.street ? 'is-invalid': 'is-valid') + ' form-control'" v-model="userInfo.street" v-on:keyup="findStreet" placeholder="Вулиця">
                        <div class="street-suggestions-section" v-if="streetSuggestions.length">
                            <div>
                                <div v-for="street in streetSuggestions" :key="street.id"
                                     style="padding: 7px;padding-left: 14px;font-weight: bold;cursor:pointer;"
                                     @click="selectStreetPrice(street)">
                                    {{ street.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 7px;font-size: 0.9rem;background-color: #AB2321;color: #fff;text-align: center;padding: 7px;" v-if="showMinPriceAlert()">
                        На жаль, мінімальна сума замовлення за Вашою адресою: <b>{{ minPrice }}</b> грн
                    </div>
                    <div style="margin-top: 7px;font-size: 0.9rem;background-color: #AB2321;color: #fff;text-align: center;padding: 7px;" v-if="!checkStreetAvailability()">
                        На жаль, Ваша адреса поза межами зони доставки
                    </div>
                    <div style="margin-top: 14px;display: flex;justify-content: space-between">
                        <div style="width: 48%">
                            <input type="text" :class="(!userInfo.house ? 'is-invalid': 'is-valid') + ' form-control'" v-model="userInfo.house" placeholder="Будинок">
                        </div>
                        <div style="width: 48%">
                            <input type="text" class="form-control" v-model="userInfo.apartment" placeholder="Квартира">
                        </div>
                    </div>

                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;">Час доставки:</div>
                        <select class="form-control" id="exampleFormControlSelect2" v-model="userInfo.delivery_at">
                            <option v-for="time in this.deliveryWorkTimes" :value="time.value">
                                {{ time.start }} {{ time.end ? '- ' + time.end  : ''}}
                            </option>
                        </select>
                    </div>
                </div>

                <div style="margin-top: 14px">
                    <select :class="(!userInfo.payment_type && type == 'delivery' ? 'is-invalid': 'is-valid') + ' form-control'" id="payment_type" v-model="userInfo.payment_type">
                        <option value="" :disabled="type == 'delivery'" selected>Оплата</option>
                        <option value="Готівка">Готівка</option>
                        <option value="Картка">Картка</option>
                        <option value="Оплата карткою online" style="font-weight: bold;">Оплата карткою online
                        </option>
                    </select>
                </div>

                <div style="margin-top: 14px">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                              v-model="userInfo.comment" placeholder="Побажання">></textarea>
                </div>

                <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center; width: 100%">
                        <label class="form-check-label" style="font-size: 1.1rem">Не телефонувати</label>
<!--                        <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="userInfo.call_back">-->
                    <toggle-button :color="{checked: '#AB2321', unchecked: '#787880', disabled: '#CCCCCC'}" switch-color="white" :width=51 :height=31 :v-model=userInfo.call_back />
                </div>

                <div style="margin-top: 14px">
                    <button class="order-button" @click="order()" :disabled="ordered">Замовити</button>
                </div>
                <br>
            </div>
        </div>

        <div class="center-cart-section" v-if="!products.length && !finished">
            <div style="margin-bottom: 25px">
                <inline-svg src="/img/icons/shopping-cart.svg" width="70" height="70"
                            :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                <br>
                Ваш кошик порожній
            </div>
        </div>

        <div class="center-cart-section" v-if="payOnline && !finished">
            <div id="liqpay_checkout"></div>
        </div>

        <div class="center-cart-section" v-if="finished">
            {{ orderText }}
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import InlineSvg from 'vue-inline-svg';
import {ToggleButton} from 'vue-js-toggle-button'

export default {
    name: 'Cart',
    components: {
        VueSimpleSuggest,
        InlineSvg,
        ToggleButton
    },
    data() {
        return {
            deliveryWorkTimes: [],
            isValidPhone: false,

            userInfo: {
                'name': '',
                'phone': '',
                'location_id': null,
                'city': '',
                'street': '',
                'house': '',
                'apartment': '',
                'payment_type': '',
                'comment': '',
                'call_back': false,
                'delivery_at': null
            },
            type: 'delivery',
            errors: [],
            products: [],
            pizzas: [],
            beverages: [],
            ordered: false,
            finished: false,
            payOnline: false,

            takeAwayDiscount: 0,
            showSecondPizzaOf: false,
            secondPizzaOfDiscount: 0,
            fourPizzaDiscount: 0,
            freeBeverages: [
                {
                    "id": 43,
                    "title": "Coca-Cola",
                    "description": null,
                    "thumbnail": "https://api.pizza.black/Coca_Cola_1000.jpg",
                    "size_30": null,
                    "size_50": null,
                    "size": "1000 ml",
                    "weight": null,
                    "volume": "1000",
                    "is_addition": 0,
                    "show_options": 1,
                    "cost_30": null,
                    "cost_50": null,
                    "price_30": null,
                    "price_50": null,
                    "cost": 15,
                    "price": 35,
                    "order": null,
                    "updated_at": null,
                    "created_at": null,
                    "additionaIngredients": [],
                    "quanity": 1,
                    "priceWithoutAdditionals": 35,
                    "freeBeverage": true
                },
                {
                    "id": 44,
                    "title": "Sprite",
                    "description": null,
                    "thumbnail": "https://api.pizza.black/Coca_Cola_1000.jpg",
                    "size_30": null,
                    "size_50": null,
                    "size": "1000 ml",
                    "weight": null,
                    "volume": "1000",
                    "is_addition": 0,
                    "show_options": 1,
                    "cost_30": null,
                    "cost_50": null,
                    "price_30": null,
                    "price_50": null,
                    "cost": 15,
                    "price": 35,
                    "order": null,
                    "updated_at": null,
                    "created_at": null,
                    "additionaIngredients": [],
                    "quanity": 1,
                    "priceWithoutAdditionals": 35,
                    "freeBeverage": true
                },
                {
                    "id": 45,
                    "title": "Fanta",
                    "description": null,
                    "thumbnail": "https://api.pizza.black/Coca_Cola_1000.jpg",
                    "size_30": null,
                    "size_50": null,
                    "size": "1000 ml",
                    "weight": null,
                    "volume": "1000",
                    "is_addition": 0,
                    "show_options": 1,
                    "cost_30": null,
                    "cost_50": null,
                    "price_30": null,
                    "price_50": null,
                    "cost": 15,
                    "price": 35,
                    "order": null,
                    "updated_at": null,
                    "created_at": null,
                    "additionaIngredients": [],
                    "quanity": 1,
                    "priceWithoutAdditionals": 35,
                    "freeBeverage": true
                }
            ],
            freeBeverageIndex: 0,
            showThreePizzaDiscount: false,
            streets: '',
            streetSuggestions: [],
            selectedStreet: '',
            minPrice: 0,
            takeawayLocations: [],
            cities: [],
            selectedCity: '',
            orderText: 'Дякуємо за замовлення! Очікуйте дзвінка!'
        }
    },

    watch: {
        products: function (newProducts, oldProducts) {
            this.checkDiscount();
        },
    },

    methods: {
        validatePhoneField(event) {
            const validationRegex = /^\d{10}$/;
            if (this.userInfo.phone.match(validationRegex)) {
                this.isValidPhone = true;
            } else {
                this.isValidPhone = false;
            }
        },

        removeProduct(product) {
            this.$store.commit('removeFromCart', product);
            this.products = this.$store.state.cart;
        },

        getProductPrice(product) {
            return product.price * product.quanity;
            return product.discountPrice ? product.discountPrice * product.quanity : product.price * product.quanity;
        },

        changeQuanity(way, product) {
            if (way == 'minus') {
                if (product.quanity == 1) {
                    return;
                }
                product.quanity--;
            }

            if (way == 'plus') {
                product.quanity++;
            }
            this.checkDiscount();

            this.$forceUpdate();
        },


        checkStreetAvailability() {
            if (this.selectedStreet && !this.selectedStreet.is_available) {
                return false;
            }

            return true;
        },

        checkForm() {
            this.errors = [];
            if (!this.userInfo.phone || !this.isValidPhone) {
                this.errors.push('Вкажіть валідний номер телефону');
                return false;
            }

            if (this.type == 'delivery') {
                if (!this.selectedCity) {
                    this.errors.push('Оберіть населений пункт');
                    return false;
                }

                if (this.selectedCity.is_validate_streets && (!this.selectedStreet || !this.selectedStreet.name)) {
                    this.errors.push('Оберіть коректну вулицю зі списку');
                    return false;
                }

                if (this.selectedCity.is_validate_streets) {
                    let streets = this.streets.find(street => street.name == this.userInfo.street)
                    if (streets.length == 0) {
                        this.errors.push('Оберіть коректну вулицю зі списку');
                        return false;
                    }
                }

                if (this.selectedStreet && !this.selectedStreet.is_available) {
                    this.errors.push(`На жаль, Ваша адреса поза межами зони доставки`);
                    return false;
                }

                if (this.showMinPriceAlert()) {
                    this.errors.push(`На жаль, мінімальна сума замовлення за Вашою адресою: ${this.minPrice} гривень`);
                    return false;
                }

                if (!this.userInfo.payment_type) {
                    this.errors.push('Оберіть тип оплати');
                    return false;
                }
            }

            if (this.type == 'take-away') {
                if (!this.userInfo.location_id && this.takeawayLocations.length > 0) {
                    this.errors.push('Оберіть точку для самовиносу');
                    return false;
                }
            }
            // if(!this.userInfo.name) {
            //     this.errors.push('Вкажіть ім\'я');
            //     return false;
            // }
            return true;
        },

        findStreet(event) {
            const selectedCity = this.selectedCity;
            this.streetSuggestions = this.streets.filter(function filterByID(street) {
                if (street.city_id == selectedCity.id && street.name.toUpperCase().includes(event.target.value.toUpperCase())) {
                    return true;
                }
                return false;
            });
            this.selectedStreet = null;
        },

        selectStreetPrice(street) {
            this.userInfo.street = street.name;
            this.selectedStreet = street;
            this.minPrice = this.selectedStreet.min_price;
            this.streetSuggestions = [];
        },

        selectCity(event) {
            let city = this.cities.find(city => city.name == event.target.value);
            this.selectedCity = city;
            this.minPrice = this.selectedCity.min_price;

            this.userInfo.street = '';
            this.selectedStreet = '';
        },

        showMinPriceAlert() {
            return (this.minPrice > (this.getTotalPrice() - this.getTotalDiscount()));
        },

        order() {
            this.ordered = true;
            this.$set(this.userInfo, 'type', this.type);
            if (this.checkForm() == false) {
                this.ordered = false;
                window.scrollTo(0, 0);
                return;
            }

            if(this.type != 'take-away') {
                this.$set(this.userInfo, 'location_id', null);
            }

            this.$set(this.userInfo, 'discount', this.getTotalDiscount());

            let url = `${Vue.prototype.SERVER_URL}/api`;

            if(localStorage.getItem('locationCityId')) {
                url += '/' + localStorage.getItem('locationCityId');
            }
            url += '/order';
            // let url = localStorage.getItem('locationCityId')
            axios.post(url, {
                order: this.userInfo,
                products: this.products
            }).then(response => {
                this.ordered = false;
                gtag('event', 'conversion', {
                    'send_to': 'AW-700415606/945qCJq978UBEPb8_c0C',
                    'transaction_id': response.data.id,
                    'value': response.data.total_price,
                    'currency': 'UAH'
                });

                dataLayer.push({
                    'event': 'conversion'
                });

                if (this.userInfo.payment_type == 'Оплата карткою online') {
                    window.open(`https://api.pizza.black/payment/liqpay/${response.data.id}`, '_blank');
                    this.payOnline = false;
                    this.finished = true;

                    // this.payOnline = true;
                    // this.finished = false;
                    //
                    // LiqPayCheckout.init({
                    //     data: response.data.liqpay_data,
                    //     signature: response.data.liqpay_signature,
                    //     embedTo: "#liqpay_checkout",
                    //     language: "uk",
                    //     mode: "embed" // embed || popup
                    // }).on("liqpay.callback", (data) => {
                    //     if (data.status == "success") {
                    //         this.payOnline = false;
                    //         this.finished = true;
                    //         this.$store.commit('emptyCart');
                    //         this.products = this.$store.state.cart;
                    //         setTimeout(() => {
                    //             let liqpayElement = document.getElementById('liqpay_checkout');
                    //             liqpayElement.innerHTML = "";
                    //             this.ordered = false;
                    //             this.finished = false;
                    //         }, 2000);
                    //     }
                    //
                    // }).on("liqpay.ready", function (data) {
                    //     // ready
                    // }).on("liqpay.close", function (data) {
                    //     // close
                    // });

                    // window.LiqPayCheckoutCallback = function() {

                    // };
                    // window.LiqPayCheckoutCallback();
                } else {
                    // this.orderText = response.data.text;
                    this.finished = true;
                    this.$store.commit('emptyCart');
                    this.products = this.$store.state.cart;
                    setTimeout(() => {
                        this.ordered = false;
                        this.finished = false;
                    }, 2000);
                }
            }).catch(e => {
                this.errors.push(e.response.data.status);
            });
        },

        getTotalPrice() {
            let totalPrice = 0;
            this.products.forEach(e => {
                totalPrice += e.price * e.quanity;
            });
            return totalPrice;
        },

        changeOrderType(type) {
            this.type = type;
            this.checkDiscount();
        },

        checkDiscount() {
            let numberOfPizzas = 0;
            this.showSecondPizzaOf = false;
            this.showThreePizzaDiscount = false;

            this.takeAwayDiscount = 0;
            this.secondPizzaOfDiscount = 0;
            this.fourPizzaDiscount = 0;

            for (let i = 0; i < this.products.length; i++) {
                if (this.products[i].category_id == 1) {
                    this.$set(this.products[0], 'discountPrice', 0);
                    numberOfPizzas += this.products[i].quanity;
                }
            }

            let hasFreeBeverageIndex = this.getSelectedFreeBeverageIndex();
            if (numberOfPizzas != 2 && hasFreeBeverageIndex != -1) {
                this.products.splice(hasFreeBeverageIndex, 1);
            }

            if (numberOfPizzas == 2) {
                this.takeAwayDiscount = 0;

                let hasFreeBeverage = this.getSelectedFreeBeverageIndex();
                if (hasFreeBeverage == -1) {
                    this.products.push(this.freeBeverages[this.freeBeverageIndex]);
                }

                if (hasFreeBeverage > -1) {
                    this.secondPizzaOfDiscount = this.freeBeverages[this.freeBeverageIndex].price;
                }

                this.showSecondPizzaOf = true;
            }

            if (numberOfPizzas == 3) {
                this.showThreePizzaDiscount = true;
            }

            if (numberOfPizzas >= 4) {
                this.fourPizzaDiscount = 0;
                let numberOfFreePizzas = Math.floor(numberOfPizzas / 4);
                while (numberOfFreePizzas > 0) {
                    for (let i = 0; i < this.products.length; i++) {
                        if (numberOfFreePizzas == 0) {
                            break;
                        }
                        if (this.products[i].category_id == 1) {
                            for (let j = 0; j < this.products[i].quanity; j++) {
                                if (numberOfFreePizzas == 0) {
                                    break;
                                }
                                this.fourPizzaDiscount += Math.round(this.products[i].priceWithoutAdditionals / 2);
                                numberOfFreePizzas--;
                            }
                        }
                    }
                }
            }

            if (this.type == 'take-away' && this.secondPizzaOfDiscount == 0 && this.fourPizzaDiscount == 0 && numberOfPizzas == 1) {
                this.getTakeAwayDiscount();
            }

            localStorage.setItem('cart', JSON.stringify(this.products));
        },

        getTakeAwayDiscount() {
            this.takeAwayDiscount = Math.round((this.getTotalPrice() - this.getTotalDiscount()) * 0.07);
        },

        getTotalDiscount() {
            return Math.round(this.takeAwayDiscount + this.secondPizzaOfDiscount + this.fourPizzaDiscount);
        },

        getSelectedFreeBeverageIndex() {
            return this.products.findIndex(e => e.freeBeverage == 1);
        },

        getSelectedFreeBeverage() {
            return this.getSelectedFreeBeverageIndex() ? this.products[this.getSelectedFreeBeverageIndex()] : null;
        },

        getSelectedFreeBeverageId() {
            return this.getSelectedFreeBeverage() ? this.getSelectedFreeBeverage().id : null;
        },

        changeFreeBeverage(index) {
            this.freeBeverageIndex = index;
            let hasFreeBeverageIndex = this.getSelectedFreeBeverageIndex();
            if (hasFreeBeverageIndex != -1) {
                this.products.splice(hasFreeBeverageIndex, 1);
            }
            this.products.push(this.freeBeverages[this.freeBeverageIndex]);
            localStorage.setItem('cart', JSON.stringify(this.products));
        },

        getFreeBeverageID() {
            return this.products.find(e => e.freeBeverage == 1).id;
        },

        selectStreet(street) {
            this.userInfo.street = street.display;
        },

        getSuggestionList(street) {
            return fetch(`https://api.pizza.black/api/street/${street}`, {method: 'GET'})
                .then(response => response.json())
                .then(json => json.items); /*
                returns a promise with a list of star-wars characters
                */
        }
    },

    mounted() {
        document.querySelector('body').style.overflow = '';

        this.products = this.$store.state.cart;

        this.$store.dispatch('getFreeBeverages').then(beverages => {
            this.freeBeverages = beverages;
        });

        this.$store.dispatch('getTakeawayLocations').then(takeawayLocations => {
            this.takeawayLocations = takeawayLocations;
        });

        this.$store.dispatch('getCities').then(cities => {
            this.cities = cities;
        });

        this.$store.dispatch('getStreets').then(streets => {
            this.streets = streets;
        });

        this.$store.dispatch('getDeliveryTimes').then(deliveryTimes => {
            this.deliveryWorkTimes = deliveryTimes;
        });
    }
}
</script>

<style>
.order-button {
    background-color: #AB2321;
    border: unset;
    width: 100%;
    border-radius: 8px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #fff;
    font-weight: bold;
}

.order-button:disabled,
.order-button[disabled] {
    opacity: 0.1;
}

.center-cart-section {
    width: 100%;
    font-weight: bold;
    padding: 0;
}

.cart-quanity-box {
    height: 43px;
    width: 43px;
    border: 1px solid #eee;
    border-radius: 50%;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-type-text, .order-type-text-selected {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 50%;
    height: 40px;

    border-radius: 6px;

    color: white;
    font-weight: 700;
    text-align: center;

}
.order-type-text {
    cursor: pointer;
}

.order-type-text-selected {
    background: #AB2321;
}

.selected-free-beverage {
    opacity: 1 !important;
    font-weight: bold;
}

.cart-total-amounts {
    display: flex;
    justify-content: space-between;
    width: 100%;

    margin-bottom: 16px;
}

.cart-total-amounts__title {
    font-size: 1.1rem;
    font-weight: 700;
    color: black;
}

.dark {
    .cart-total-amounts__title {
        color: white;
    }
}

.cart-total-amounts__value {
    font-size: 1.1rem;
    font-weight: 700;
    color: #AB2321;
}

.autocomplete__icon {
    display: none;
}

.autocomplete__box {
    border: 0 !important;
    padding: 0 !important;
}

.autocomplete__results {
    left: 0;
}

.vue-simple-suggest.designed .input-wrapper input {
    border: 1px solid #ced4da;
    padding: .375rem .75rem;
}

.street-suggestions-section {
    position: absolute;
    width: 100%;
    background-color: rgb(255, 255, 255);
    top: calc(100% + 7px);
    border: 1px solid rgb(206, 212, 218);
    border-radius: 0.25rem;
    max-height: 340px;
    overflow-y: scroll;
    z-index: 999;
}

.street-suggestions-section::-webkit-scrollbar {
    width: 0.2em;
}

.street-suggestions-section::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.street-suggestions-section::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}

.cart-product-box {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgb(171, 35, 33);
    margin-bottom: 15px;
    padding-bottom: 20px;
    position: relative;
}

.cart-product-box__body {
    display: flex;
}

.cart-product-box__title {
    padding-right: 30px;
    text-align: left;
    font-weight: bold;
    font-size: 1.1rem;
    color: #AB2321;
}

.cart-product-box__description {
    text-align: left;
    font-size: 0.9rem;
    color: black;
}

.dark {
    .cart-product-box__description {
        color: white;
    }
}

.cart-free-beverage-box {
    margin-bottom: 14px;
    border: 1px solid rgb(238, 238, 238);
    border-radius: 8px;
    padding: 7px 4px;
}

.cart-order-type-box {
    display: flex;
    margin-top: 34px;
    border-radius: 6px;
    background: #BAAEAE;
}


.free-beverage__list {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    overflow-x: auto;
}
.free-beverage__list::-webkit-scrollbar {
    width: 2px;
}

.free-beverage__list::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
}

.free-beverage__list::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}


.free-beverage__list {
    scrollbar-width: auto;
    scrollbar-color: #39455c #17191e;
}

/* Chrome, Edge, and Safari */
.free-beverage__list::-webkit-scrollbar {
    width: 4px;
}

.free-beverage__list::-webkit-scrollbar-track {
    background: #17191e;
}

.free-beverage__list::-webkit-scrollbar-thumb {
    background-color: #39455c;
    border-radius: 10px;
    border: 1px solid #17191e;
}

.free-beverage__item {
    cursor: pointer;
}

</style>
